import React, { useState } from "react"
import { selectValuation } from "../../redux/valuations.slice"
import { inflateFromRight } from "../../components/Animations"
import { useDispatch, useSelector } from "react-redux"
import { useSpring, animated } from "react-spring"
import useDeviceType from "../../utils/useDeviceType"
import { BottomSheet } from "react-spring-bottom-sheet"
import Modal from "../../components/Modal"
import ValuationList from "../../components/ValuationList"
import PageContent from "./PageContent"

const ErrorPage = ({ type = "error" }) => {
  const dispatch = useDispatch()
  const pageStyle = useSpring(inflateFromRight)
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false)
  const [isValModalOpen, setIsValModalOpen] = useState(false)
  const { valuations, currentValuation } = useSelector(
    (store) => store.valuationsDetails
  )
  const { isMobileView, isDesktopView } = useDeviceType()

  const closeMenu = () => {
    if (isMobileView) setIsBottomSheetOpen(false)
    else setIsValModalOpen(false)
  }

  const handleSelectValuation = (valuation) => {
    dispatch(
      selectValuation({
        authToken: valuations[currentValuation].authToken,
        valuationId: valuation.id,
      })
    )
    closeMenu()
  }

  return (
    <animated.div className="flex flex-col px-5 h-screen" style={pageStyle}>
      <PageContent type={type} setIsBottomSheetOpen={setIsBottomSheetOpen} setIsValModalOpen={setIsValModalOpen} />
      {isBottomSheetOpen && isMobileView && (
        <BottomSheet
          open={isBottomSheetOpen}
          defaultSnap={({ maxHeight }) => maxHeight * 0.3}
          onDismiss={closeMenu}
        >
          <div className="p-5">
            <ValuationList handleSelect={handleSelectValuation} />
          </div>
        </BottomSheet>
      )}
      {isValModalOpen && isDesktopView && (
        <Modal
          className="w-1/2 thin-scrollbar p-5"
          isVisible={isValModalOpen}
          onToggle={() => {
            setIsValModalOpen(false)
          }}
        >
          <ValuationList handleSelect={handleSelectValuation} />
        </Modal>
      )}
    </animated.div>
  )
}

export default ErrorPage
